import React, { useEffect, useState, useCallback } from "react";

import s from "./SplashScreen.module.css";

export const SplashScreen = ({ onFinishLoading }: { onFinishLoading: () => void }) => {
	const [loadingSplash, setLoadingSplash] = useState(true);
	const [fadeOut, setFadeOut] = useState(false);

	const videoRef = useCallback((node: HTMLVideoElement | null) => {
		if (node) {
			node.playbackRate = 1.75;
		}
	}, []);

	useEffect(() => {
		if (loadingSplash) {
			const timer = setTimeout(() => {
				setFadeOut(true);
				setTimeout(() => {
					setLoadingSplash(false);
					onFinishLoading();
				}, 1000);
			}, 3000);

			return () => clearTimeout(timer);
		}
	}, [loadingSplash]);

	if (!loadingSplash) return null;

	return (
		<div className={`${s.container} ${fadeOut ? s.fadeOut : ""}`}>
			<div className={s.video_wrapper}>
				<video ref={videoRef} className={s.video} src="/videos/splash-screen.mp4" autoPlay muted playsInline />
			</div>
		</div>
	);
};
